var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14.857,
    viewBox: "0 0 13 14.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-alt",
    "data-name": "Icon awesome-calendar-alt",
    d: "M0,13.464a1.393,1.393,0,0,0,1.393,1.393H11.607A1.393,1.393,0,0,0,13,13.464V5.571H0ZM9.286,7.777a.349.349,0,0,1,.348-.348h1.161a.349.349,0,0,1,.348.348V8.938a.349.349,0,0,1-.348.348H9.634a.349.349,0,0,1-.348-.348Zm0,3.714a.349.349,0,0,1,.348-.348h1.161a.349.349,0,0,1,.348.348v1.161a.349.349,0,0,1-.348.348H9.634a.349.349,0,0,1-.348-.348ZM5.571,7.777a.349.349,0,0,1,.348-.348H7.08a.349.349,0,0,1,.348.348V8.938a.349.349,0,0,1-.348.348H5.92a.349.349,0,0,1-.348-.348Zm0,3.714a.349.349,0,0,1,.348-.348H7.08a.349.349,0,0,1,.348.348v1.161A.349.349,0,0,1,7.08,13H5.92a.349.349,0,0,1-.348-.348ZM1.857,7.777a.349.349,0,0,1,.348-.348H3.366a.349.349,0,0,1,.348.348V8.938a.349.349,0,0,1-.348.348H2.205a.349.349,0,0,1-.348-.348Zm0,3.714a.349.349,0,0,1,.348-.348H3.366a.349.349,0,0,1,.348.348v1.161A.349.349,0,0,1,3.366,13H2.205a.349.349,0,0,1-.348-.348Zm9.75-9.634H10.214V.464A.466.466,0,0,0,9.75,0H8.821a.466.466,0,0,0-.464.464V1.857H4.643V.464A.466.466,0,0,0,4.179,0H3.25a.466.466,0,0,0-.464.464V1.857H1.393A1.393,1.393,0,0,0,0,3.25V4.643H13V3.25A1.393,1.393,0,0,0,11.607,1.857Z",
    fill: "#bf772f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.342dcecf92d0f05fa1ef1df8525a621e.svg";
export { ForwardRef as ReactComponent };